export enum LoadingState {
  Loading,
  Submitting,
  Idle,
}
